import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115249ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-left-bd card-left-bd--failed" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "card-left-bd--title"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, " *我们为你准备了腾讯专属纪念奖品，请您扫描下方二维码关注开放实验平台公众号，并留下您的邮寄地址，我们将为您寄送奖品 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, "*邮寄信息将通过公众号推送，请您关注并留意公众号动态", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "card-left-bd--subtitle"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, "*同时希望您填写简单的问卷，帮助我们做得更好", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "card-left-bd--title"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, " *感谢您对本比赛的关注与参与，取得前3名队伍的奖品具体发放事宜会有工作人员与您取得联系，其他名次我们会将纪念品邮寄给您，请您扫描下方二维码关注开放实验平台公众号，并留下您的邮寄地址，我们将为您寄送奖品（邮寄信息将通过公众号推送，请您关注并留意公众号动态） ", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "card-left-bd--title"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, " *感谢您对本比赛的关注与参与，我们为您准备了腾讯专属纪念品，请您扫描下方二维码关注开放实验平台公众号，并留下您的邮寄地址，我们将为您寄送礼品（邮寄信息将通过公众号推送，请您关注并留意公众号动态） ", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "card-left-bd--title"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, " *感谢您对本比赛的关注与参与，我们为您准备了腾讯专属纪念品，请您扫描下方二维码关注开放实验平台公众号，并留下您的邮寄地址，我们将为您寄送礼品（邮寄信息将通过公众号推送，请您关注并留意公众号动态） ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-left-bd--subtitle" }, "*同时希望您填写简单的问卷，帮助我们做的更好", -1))
const _hoisted_22 = { class: "card-left-bd--btm" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/h5/2021-9/taop公众号-ac2dc8259be06256e66f2fb38304c6fe.png",
  alt: "",
  class: "card-left-bd--btm__img"
}, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "postAddress"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("修改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.stepState < 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "card-left-bd--title",
            style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'color: #000000' : '')
          }, "很遗憾您未进入复赛阶段，期待下次比赛您能取得更好成绩！", 4),
          (_ctx.isFeedbackEndTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "本次大赛圆满结束，本页面所有操作关闭"))
            : _createCommentVNode("", true),
          (_ctx.stepState === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.stepState === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "*请您扫描下方二维码关注开放实验平台公众号，后续比赛信息将通过公众号推送。"))
            : _createCommentVNode("", true),
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.stepState >= 3 && _ctx.stepState <= 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.stepState === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.isAttendFinal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: "card-left-bd--title",
                        style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'color: #000000' : '')
                      }, "本次AI大赛圆满结束，恭喜您在决赛取得优秀名次", 4),
                      (_ctx.isFeedbackEndTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "本次大赛圆满结束，本页面所有操作关闭"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalRank, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "card-left-bd--subtitle"
                        }, " *恭喜您在 " + _toDisplayString(item.name) + " 获得了 第" + _toDisplayString(item.rank) + "名 的成绩 ", 1))
                      }), 128)),
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: "card-left-bd--title",
                        style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'color: #000000' : '')
                      }, "本次AI大赛已结束，感谢您的参与和精彩表现", 4),
                      (_ctx.isFeedbackEndTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, "本次大赛圆满结束，本页面所有操作关闭"))
                        : _createCommentVNode("", true),
                      _hoisted_17
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.stepState === 3 || _ctx.stepState === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "card-left-bd--title",
                  style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'color: #000000' : '')
                }, "很遗憾您未进入决赛阶段，期待下次比赛您能取得更好成绩！", 4),
                (_ctx.isFeedbackEndTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "本次大赛圆满结束，本页面所有操作关闭"))
                  : _createCommentVNode("", true),
                _hoisted_20
              ]))
            : _createCommentVNode("", true),
          _hoisted_21
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createVNode(_component_Form, {
        "label-position": "left",
        model: _ctx.formValue,
        rules: _ctx.rules,
        ref: "addressForm",
        "label-width": "98px",
        class: "card-left-bd--btm__ruleForm"
      }, {
        default: _withCtx(() => [
          (_ctx.stepState > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_FormItem, {
                  label: "邮寄地址：",
                  prop: "Address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.formValue.Address,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.Address) = $event)),
                      type: "text",
                      maxlength: "50",
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormItem, {
                  label: "收件人：",
                  prop: "RecName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.formValue.RecName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValue.RecName) = $event)),
                      type: "text",
                      maxlength: "10",
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormItem, {
                  label: "联系电话：",
                  prop: "RecTel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.formValue.RecTel,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValue.RecTel) = $event)),
                      type: "number",
                      maxlength: "11",
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_FormItem, {
            class: "feedback",
            label: _ctx.feedbackQues.get('1')[0],
            prop: "Ques1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RadioGroup, {
                modelValue: _ctx.formValue.Ques1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValue.Ques1) = $event)),
                disabled: _ctx.isDisabled,
                size: "mini"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.feedbackQues.get('1')[1]), (item, index) => {
                    return (_openBlock(), _createBlock(_component_Radio, {
                      key: index,
                      label: `${index + 1}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_FormItem, {
            class: "feedback",
            label: _ctx.feedbackQues.get(_ctx.stepState === 1 ? '3' : '2')[0],
            prop: "Ques2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RadioGroup, {
                modelValue: _ctx.formValue.Ques2,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValue.Ques2) = $event)),
                disabled: _ctx.isDisabled
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.feedbackQues.get(_ctx.stepState === 1 ? '3' : '2')[1]), (item, index) => {
                    return (_openBlock(), _createBlock(_component_Radio, {
                      key: index,
                      label: `${index + 1}`,
                      style: {"font-size":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_FormItem, {
            class: "feedback-textarea",
            label: _ctx.feedbackQues.get('4')[0],
            prop: "Suggestion"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                modelValue: _ctx.formValue.Suggestion,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValue.Suggestion) = $event)),
                type: "textarea",
                maxlength: "300",
                "show-word-limit": "",
                disabled: _ctx.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_FormItem, { class: "button" }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm())),
                disabled: _ctx.isFeedbackEndTime,
                style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'border: #a0cfff' : '')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.leftText), 1)
                ]),
                _: 1
              }, 8, ["disabled", "style"]),
              _createVNode(_component_Button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetForm())),
                disabled: _ctx.isFeedbackEndTime,
                style: _normalizeStyle(_ctx.isFeedbackEndTime ? 'color: #909399' : '')
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}